import Filter from '@helpers/Filter';
import { PointItem } from './index.d';

const daySecond = 24 * 60 * 60 * 1000;

//获取停留时长字符串
export const getStageTime = (aTime: number, lTime: number) => {
  const ts = lTime - aTime;
  const h = Math.floor(ts / (daySecond /  24));
  let minute = 0;
  let t = '';
  if(h >= 1) {
    const m = ts - h * 60 * 60 * 1000;
    minute = Math.floor(m / (60 * 1000));
    t = h + 'h' + ( minute > 0 ? minute + 'min' : '');
  }else {
    minute = Math.floor(ts / (60 * 1000));
    t = minute + 'min';
  }
  return t;
}

//判断是否是驻留点
export const checkIsStagePoint = (item: any) => {
  return item?.arriveTime && item?.leaveTime && ((item.leaveTime - item.arriveTime) >= 15 * 60 * 1000);
}

export const getDates = (): any => {
  let date = Date.now();
  date = Filter.date(date, 'date') as any;
  let lastDate = Date.now() - daySecond;
  lastDate = Filter.date(lastDate, 'date') as any;
  let beforeLastDate = Date.now() - daySecond * 2;
  beforeLastDate = Filter.date(beforeLastDate, 'date') as any;
  const times = [
    {
      title: '今天',
      value: date
      //value: '2022-01-11'
    },
    {
      title: '昨天',
      value: lastDate
    },
    {
      title: '前天',
      value: beforeLastDate
    }
  ]
  return times;
}

//计算两个经纬度坐标点间的角度值
// export const getPointAngle = (firstPoint: Point, nextPoint: Point) => {
//   if (!(firstPoint && nextPoint)) {
//     return 0;
//   }

//   let dRotateAngle = Math.atan2(
//     Math.abs(firstPoint.lng - nextPoint.lng),
//     Math.abs(firstPoint.lat - nextPoint.lat)
//   );
//   if (nextPoint.lng >= firstPoint.lng) {
//     if (nextPoint.lat < firstPoint.lat) {
//       dRotateAngle = Math.PI - dRotateAngle;
//     }
//   } else {
//     if (nextPoint.lat >= firstPoint.lat) {
//       dRotateAngle = 2 * Math.PI - dRotateAngle;
//     } else {
//       dRotateAngle = Math.PI + dRotateAngle;
//     }
//   }
//   dRotateAngle = (dRotateAngle * 180) / Math.PI;
//   return dRotateAngle;
// }

//计算经纬度之间的距离
export const getDistance = (sp: any, ep: any) =>{
  let getRad = (d: any) => (d * Math.PI) / 180.0; //经纬度转换成三角函数中度分表形式
  let radLat1 = getRad(sp.lat);
  let radLat2 = getRad(ep.lat);
  let a = radLat1 - radLat2;
  let b = getRad(sp.lon) - getRad(ep.lon);
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378137; //地球半径6378137(米);
  return s;
}

//计算两个坐标点之间的补充点
export const getFillPoints = (sp: PointItem, ep: PointItem, d: number, r: number, maxNum = 30) => {
  if (!(sp && ep && d && r)) {
    return [];
  }
  let lngDiff = ep.lon - sp.lon; //起点与终端经度差
  let latDiff = ep.lat - sp.lat; //起点与终端纬度差
  let n = Math.ceil(d / r); //补点的总数

  if(n >= maxNum) {   //默认补点个数限制为30
    n = maxNum;
  }

  // if(n <= 1) { // 如果当前距离太近是否考虑要添加补充点
  //   n = 10;
  // }
  let a = lngDiff / n; //每步的经度差
  let b = latDiff / n; //每步的纬度差
  let points = []; //坐标数组

  for (let i = 1; i < n; i++) {
    let lon = sp.lon + a * i;
    let lat = sp.lat + b * i;
    points.push({
      lon, lat,
      locationName: sp.locationName + '附近',
      arriveTime: sp.arriveTime
    });
  }

  return points;
}